(ns ui.components.icon-button.zapkit-styles)

;; ----------------------------------------------------------------------------
;; AUTO-GENERATED FILE — DO NOT EDIT MANUALLY.
;; Regenerate via: scripts/convert_zapkit_json.bb <source>.json <output-dir-or-file>
;; (run from the project root directory).
;; Source: zapkit-components/src/components/IconButton/styles.json
;; Source commit: ab84e5aca876ac5a50d0da5ebe6ccba5349bbeeb
;; ----------------------------------------------------------------------------

(def icon-button
  {:root
   {:base
    "tw2-inline-flex tw2-items-center tw2-justify-center tw2-rounded-icon-btn tw2-transition-all tw2-duration-200 focus-visible:tw2-outline-none focus-visible:tw2-outline-2 focus-visible:tw2-outline-icon-btn-outline-focus focus-visible:tw2-outline-offset-2",
    :variant
    {:default
     "hover:tw2-text-icon-btn-default-text-hover hover:tw2-bg-icon-btn-default-bg-hover",
     :alert
     "tw2-text-icon-btn-alert-text-default hover:tw2-text-icon-btn-alert-text-hover hover:tw2-bg-icon-btn-alert-bg-hover",
     :alert-help
     "tw2-text-icon-btn-alert-help-text-default hover:tw2-text-icon-btn-alert-help-text-hover hover:tw2-bg-icon-btn-alert-help-bg-hover",
     :alert-info
     "tw2-text-icon-btn-alert-info-text-default hover:tw2-text-icon-btn-alert-info-text-hover hover:tw2-bg-icon-btn-alert-info-bg-hover",
     :alert-warning
     "tw2-text-icon-btn-alert-warning-text-default hover:tw2-text-icon-btn-alert-warning-text-hover hover:tw2-bg-icon-btn-alert-warning-bg-hover",
     :alert-success
     "tw2-text-icon-btn-alert-success-text-default hover:tw2-text-icon-btn-alert-success-text-hover hover:tw2-bg-icon-btn-alert-success-bg-hover"},
    :shrink {:true "tw2-flex-shrink-0", :false ""},
    :compact
    {:true "tw2-h-3 tw2-w-3 tw2-cursor-pointer",
     :false "tw2-w-icon-btn-size tw2-h-icon-btn-size"},
    :compound-variants
    [{:variant "default",
      :compact false,
      :class-name "tw2-text-icon-btn-default-text-default"}
     {:variant "default",
      :compact true,
      :class-name "tw2-text-card-icon-default"}],
    :default-variants
    {:variant "default", :shrink false, :compact false}},
   :icon
   {:base "",
    :size {:sm "tw2-h-3 tw2-w-3", :md "tw2-w-4 tw2-h-4"},
    :compound-variants [],
    :default-variants {:size "md"}},
   :_meta
   {:tokens
    ["card-icon-default"
     "icon-btn-alert-bg-hover"
     "icon-btn-alert-help-bg-hover"
     "icon-btn-alert-help-text-default"
     "icon-btn-alert-help-text-hover"
     "icon-btn-alert-info-bg-hover"
     "icon-btn-alert-info-text-default"
     "icon-btn-alert-info-text-hover"
     "icon-btn-alert-success-bg-hover"
     "icon-btn-alert-success-text-default"
     "icon-btn-alert-success-text-hover"
     "icon-btn-alert-text-default"
     "icon-btn-alert-text-hover"
     "icon-btn-alert-warning-bg-hover"
     "icon-btn-alert-warning-text-default"
     "icon-btn-alert-warning-text-hover"
     "icon-btn-default-bg-hover"
     "icon-btn-default-text-default"
     "icon-btn-default-text-hover"
     "icon-btn-outline-focus"
     "radius-icon-btn"
     "spacing-icon-btn-size"],
    :generated-from "src/components/IconButton/IconButton.styles.ts"}})
